// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-transcription {
    background-color: white;
    overflow-y: auto;
    display: flex;
    align-self: stretch;
    align-items: stretch;
    flex-direction: column;
    padding: 8px;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
}

.aiiif-player-container.aiiif-audio {
    position: relative;
    width: 100%;
}

.aiiif-player-container.aiiif-audio .aiiif-transcription {
    top: 42px
}

.aiiif-transcription-part.active {
    color: #CD171B;
}

.aiiif-time-code {
    min-width: 70px;
    max-width: 70px;
}

.aiiif-transcription-part {
    display: flex;
    padding-bottom: 12px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/viewer/media/transcription.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,eAAe;AACnB","sourcesContent":[".aiiif-transcription {\n    background-color: white;\n    overflow-y: auto;\n    display: flex;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n    padding: 8px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n}\n\n.aiiif-player-container.aiiif-audio {\n    position: relative;\n    width: 100%;\n}\n\n.aiiif-player-container.aiiif-audio .aiiif-transcription {\n    top: 42px\n}\n\n.aiiif-transcription-part.active {\n    color: #CD171B;\n}\n\n.aiiif-time-code {\n    min-width: 70px;\n    max-width: 70px;\n}\n\n.aiiif-transcription-part {\n    display: flex;\n    padding-bottom: 12px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
